import { useQuery } from '@tanstack/react-query';
import { Loading, EmptyState, Badge } from '@/components/ui';
import { formatNIS } from '@/utils/currency';
import { formatDate } from '@/utils/date';
import { affiliateApi } from '@/api/affiliate';

export default function CustomersTab({ partnerId }: { partnerId: string }) {
  const { data: customers, isLoading } = useQuery({
    queryKey: ['affiliate-customers', partnerId],
    queryFn: () => affiliateApi.customers.listByPartner(partnerId),
  });

  if (isLoading) return <Loading text="Loading customers…" />;
  if (!(customers ?? []).length) {
    return (
      <EmptyState
        title="No referred customers yet"
        description="Organizations that sign up through this partner's links will appear here."
      />
    );
  }

  return (
    <div className="card overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="text-left text-ink-muted text-xs uppercase">
            <th className="px-4 py-3">Organization</th>
            <th className="px-4 py-3">Referral</th>
            <th className="px-4 py-3">Current plan</th>
            <th className="px-4 py-3">Last monthly paid</th>
            <th className="px-4 py-3">Total earned</th>
            <th className="px-4 py-3">Joined</th>
          </tr>
        </thead>
        <tbody>
          {customers!.map((c) => (
            <tr key={c.referral_id} className="border-t border-navy-border">
              <td className="px-4 py-3">
                <div className="text-white">{c.org_name}</div>
                {c.org_status && <div className="text-xs text-ink-muted capitalize">{c.org_status}</div>}
              </td>
              <td className="px-4 py-3">
                <Badge variant={c.referral_status === 'active' ? 'success' : 'neutral'}>
                  {c.referral_status}
                </Badge>
              </td>
              <td className="px-4 py-3 capitalize">{c.current_plan ?? '—'}</td>
              <td className="px-4 py-3 num">
                {c.last_monthly_paid_agorot != null ? formatNIS(c.last_monthly_paid_agorot) : '—'}
              </td>
              <td className="px-4 py-3 num">{formatNIS(c.total_earned_agorot)}</td>
              <td className="px-4 py-3 text-ink-secondary">{formatDate(c.joined_at)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
